import { useEffect, useState } from 'react';

interface UseDebouncedSearchReturn {
  searchQuery: string;
  debouncedSearch: string;
  setSearchQuery: (value: string) => void;
  resetSearch: () => void;
}

export function useDebouncedSearch(delay = 250): UseDebouncedSearchReturn {
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery.trim());
    }, delay);

    return () => clearTimeout(timer);
  }, [searchQuery, delay]);

  const resetSearch = () => {
    setSearchQuery('');
    setDebouncedSearch('');
  };

  return { searchQuery, debouncedSearch, setSearchQuery, resetSearch };
}
